
import { defineComponent, PropType } from 'vue';
import { LastingDosage } from '@/service/models/common/query-dosage/dosage-choices/lasting-dosage';

export default defineComponent({
    props: {
        dosageChoice: {
            type: Object as PropType<LastingDosage>,
            required: true,
        },
    },
})
